import React, { useReducer } from "react";
import axios from "axios";
import moment from "moment";
import UserContext from "./userContext";
import UserReducer from "./userReducer";
import { } from "../types";
import { getAppUrl, getLocationApiUrl } from "../../functions/getEnv";
import setAuthToken from "../../functions/auth_header";
import ErrorLogger from "../../components/ErrorLogger";

const UserState = (props) => {
  const initialState = {
    users: [],
    user: {},
    programTypes: {},
    filteredUsers: [],
    loading: true,
    permissionsSortOptions: {
      name: { asc: false, desc: false },
      status: { asc: false, desc: false },
      charterAssignments: { asc: false, desc: false },
      action: { asc: false, desc: false },
    },
    formModal: {
      addUserPermissionModal: false,
      updateUserPermissionModal: false,
    },
    sqlUserResults: [],
    charters: [],
    filteredCharters: [],
  };


  const [state, dispatch] = useReducer(UserReducer, initialState);

  /* const localApiUrl =
    import.meta.env.MODE === `production` ? `` : `http://localhost:5000`;
  const locationsApiUrl =
    import.meta.env.MODE === `production`
      ? `https://llac-locations-api.azurewebsites.net`
      : `http://localhost:7000`; */

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const locationApiUrl = getLocationApiUrl(import.meta.env.VITE_NODE_ENV);

  // console.log('UserState');
  // console.log('appUrl:', appUrl);
  // console.log('locationApiUrl:', locationApiUrl);

  const getUsers = async () => {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }
    try {
      const res = await axios.get(`${appUrl}/api/user/`);
      dispatch({ type: "GET_USERS", payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const getUser = async (id) => {
    try {
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const res = await axios.get(`${appUrl}/api/user/${id}`);
      dispatch({ type: "GET_USER", payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const updateUser = async (id, data) => {
    try {
      const res = await axios.put(`${appUrl}/api/user/${id}`, data);
      if (data.userStatus === "General") {
        dispatch({ type: "DELETE_USER", payload: id });
      } else {
        dispatch({ type: "UPDATE_USER", payload: res.data });
      }
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const onPermissionTableFilter = (value) => {
    try {
      dispatch({ type: "FILTER_PERMISSION_TABLE", payload: value });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const searchFilter = async (text) => {
    try {
      dispatch({ type: "SEARCH_FILTER", payload: text });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const clearSearchFilter = () => {
    try {
      dispatch({ type: "CLEAR_SEARCH_FILTER" });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const setFormModal = (name, value) => {
    try {
      dispatch({ type: "SET_FORM_MODAL", payload: { name, value } });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const getSqlUsers = async (text) => {
    try {
      const res = await axios.get(`${appUrl}/api/sql/${text}`);
      dispatch({ type: "GET_SQL_USERS", payload: res.data.recordset });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };
  const clearSqlUserResults = () => {
    try {
      dispatch({ type: "CLEAR_SQL_USER_RESULTS" });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const closePersonDatabaseConnection = async () => {
    try {
      const res = await axios.post(`${appUrl}/api/sql/close-person-database`);
      dispatch({ type: "CLEAR_SQL_USER_RESULTS" });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const getCharters = async () => {
    try {
      const res = await axios.get(`${locationApiUrl}/active-charters/`);
      dispatch({ type: "GET_CHARTERS", payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const filterCharters = (text) => {
    try {
      dispatch({ type: "FILTER_CHARTERS", payload: text });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const clearFilteredCharters = () => {
    try {
      dispatch({ type: "CLEAR_FILTER_CHARTERS" });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };

  const createNewUserPermission = async (data) => {
    try {
      const res = await axios.post(`${appUrl}/api/user/`, data);
      dispatch({ type: "CREATE_NEW_PERMISSION", payload: res.data });
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };
  const getProgramTypes = async () => {
    // if (localStorage.token) {
    //   setAuthToken(localStorage.token);
    // }
    const authRes = await axios.get(`${appUrl}/auth/webapp`);
    const userAccessToken = authRes.data.accessTokens[0];
    setAuthToken(userAccessToken);
    //console.log("localStorage.token", userAccessToken)
    try {
      const res = await axios.get(`${appUrl}/api/programTypes/`);
       const programTypes = res.data.data || res.data;    
    dispatch({ type: "GET_PROGRAMTYPES", payload: programTypes });
    //console.log("Program Types", programTypes);
    } catch (error) {
      console.error(error.message);
      ErrorLogger.logError(error, "UserState.js");
    }
  };



  return (
    <UserContext.Provider
      value={{
        users: state.users,
        user: state.user,
        programTypes:state.programTypes,
        filteredUsers: state.filteredUsers,
        permissionsSortOptions: state.permissionsSortOptions,
        formModal: state.formModal,
        sqlUserResults: state.sqlUserResults,
        charters: state.charters,
        filteredCharters: state.filteredCharters,
        getUsers,
        getUser,
        updateUser,
        onPermissionTableFilter,
        searchFilter,
        clearSearchFilter,
        setFormModal,
        getSqlUsers,
        clearSqlUserResults,
        getCharters,
        filterCharters,
        clearFilteredCharters,
        createNewUserPermission,
        getProgramTypes,
        closePersonDatabaseConnection,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserState;
